import { useState } from 'react';
import { ViewModelURL } from '@user/pages/urls';
import { Link as InternalLink } from 'react-router';
import { ForeignObjectAutosize } from '@view-model/models/common/components/ForeignObjectAutosize';
import { Size } from '@view-model/models/common/basic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt, faProjectDiagram } from '@fortawesome/free-solid-svg-icons';
import './style/hyperLinkShow.css';
import { useFavicon } from './hooks/useFavicon';
import type { ViewModelId } from 'balus-common';

type Props = {
  x: number;
  y: number;
  url: string;
  viewModelId: ViewModelId;
  onClickViewModelLink?(e: React.MouseEvent): void;
};

const RECT_HEIGHT = 64;

export const HyperLinkShow: React.FC<Props> = ({ x, y, url, viewModelId, onClickViewModelLink }: Props) => {
  const viewModelURL = ViewModelURL.fromURLString(url);
  const [rectSize, setRectSize] = useState(new Size(0, RECT_HEIGHT));

  const { getFaviconURL, FAVICON_SIZE } = useFavicon(url);

  const handleSizeChange = (newSize: Size) => {
    setRectSize(new Size(newSize.width, RECT_HEIGHT));
  };

  return (
    <g transform={`translate(${x}, ${y})`}>
      <rect
        className="stroke-gray-300"
        fill={'white'}
        strokeWidth={2}
        width={rectSize.width}
        height={rectSize.height}
      />
      <ForeignObjectAutosize onSizeChange={handleSizeChange}>
        <div className="hyper-link-rect" style={{ height: rectSize.height }}>
          {viewModelURL?.isSameId(viewModelId) ? (
            // 同じViewModel内の場合
            <>
              <div className="bg-brand p-1 text-white">
                <FontAwesomeIcon icon={faProjectDiagram} size="2x" />
              </div>
              <div className="hyper-link-text">
                <InternalLink to={viewModelURL.href} onClick={onClickViewModelLink}>
                  {url}
                </InternalLink>
              </div>
            </>
          ) : (
            <>
              <img src={getFaviconURL()} width={FAVICON_SIZE} height={FAVICON_SIZE} className="shrink-0" />
              <a href={url} className="hyper-link-text mr-4" target="_blank" rel="noreferrer">
                {url}
              </a>
              <FontAwesomeIcon icon={faExternalLinkAlt} size="2x" />
            </>
          )}
        </div>
      </ForeignObjectAutosize>
    </g>
  );
};
